module.exports = __webpack_public_path__ + "static/media/red_circle.45e22823.svg";